/**
 * FairChild Institute Brand Colors
 * Centralized color configuration to maintain consistency across MUI and Tailwind
 */

export const brandColors = {
  primary: {
    main: '#631760',
    light: '#AD14A7',
    dark: '#211430',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#AD14A7',
    light: '#FFF4FF',
    dark: '#270126',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#FFFFFF',
    paper: '#FFF4FF',
  },
  text: {
    primary: '#121212',
    secondary: '#404040',
  },
  grey: {
    100: '#FFF4FF',
    200: '#F8F4F8',
    300: '#E5D1E5',
    800: '#2D2D2D',
    900: '#161616',
  },
} as const;

export const tailwindColorScale = {
  primary: {
    50: '#FFF4FF',
    100: '#FFF4FF',
    200: '#F8F4F8',
    300: '#E5D1E5',
    400: '#AD14A7',
    500: '#631760',
    600: '#631760',
    700: '#270126',
    800: '#211430',
    900: '#211430',
  },
  secondary: {
    50: '#FFF4FF',
    100: '#FFF4FF',
    200: '#F8F4F8',
    300: '#E5D1E5',
    400: '#AD14A7',
    500: '#AD14A7',
    600: '#270126',
    700: '#270126',
    800: '#211430',
    900: '#270126',
  },
} as const;

